import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Announcement = () => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("ol", {
      children: [/*#__PURE__*/_jsx("li", {
        children: "Accept the microphone permission request if you want to play your guitar"
      }), /*#__PURE__*/_jsxs("li", {
        children: ["Upload a NAM profile file (.nam) from your computer or visit ", /*#__PURE__*/_jsx("a", {
          ...stylex.props(styles.link),
          href: "https://tonehunt.org",
          children: "ToneHunt"
        }), " to preload from there"]
      }), /*#__PURE__*/_jsx("li", {
        children: "Press the button below if the profile is not automatically activated"
      }), /*#__PURE__*/_jsx("li", {
        children: "Currently resampling is disabled, please set 48KHz sample rate in your interface and load appropriate profiles and IRs"
      }), /*#__PURE__*/_jsxs("li", {
        children: ["Using\xA0", /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://www.mozilla.org/en-US/firefox/new",
          ...stylex.props(styles.link),
          children: "Mozilla Firefox"
        }), "\xA0is recommended"]
      }), /*#__PURE__*/_jsxs("li", {
        children: ["Click on the download icon at the end of your searchbar to\xA0", /*#__PURE__*/_jsx("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "https://en.wikipedia.org/wiki/Progressive_web_app",
          ...stylex.props(styles.link),
          children: "install the website"
        }), "\xA0for offline use \u279A"]
      })]
    })
  });
};